var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNabox = function SvgNabox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.98682V23.8908L6.31535 26.3785V15.717L10.6153 18.2006V28.8551L14.932 31.3428V16.4374L2 8.98682Z",
    fill: "#2AC98B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8024 7.62299L16.1261 5.089L21.4983 8.23266L17.1773 10.7554L11.8024 7.62299ZM16.1317 0L3.09741 7.62579L17.1535 15.8669V32L21.417 29.5165V13.1955L25.7253 10.6727V26.9797L30.0519 24.4331V8.14436L16.1317 0Z",
    fill: "#2AC98B"
  })));
};

export { SvgNabox as ReactComponent };
export default __webpack_public_path__ + "970740e084facb790d58ab9fe8b7b4e3.svg";